'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Form = require('antd/lib/form/Form');

var _Form2 = _interopRequireDefault(_Form);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _defineProperty = require('babel-runtime/helpers/defineProperty');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _omit = require('omit.js');

var _omit2 = _interopRequireDefault(_omit);

var _FormItem = require('./FormItem');

var _FormItem2 = _interopRequireDefault(_FormItem);

var _createFormField = require('rc-form/lib/createFormField');

var _createFormField2 = _interopRequireDefault(_createFormField);

var _createDOMForm = require('rc-form/lib/createDOMForm');

var _createDOMForm2 = _interopRequireDefault(_createDOMForm);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _constants = require('antd/lib/form/constants');

var Form = function (_AntForm) {
  _inherits(Form, _AntForm);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _classNames = void 0;

      var cloneProps = _extends({}, this.props);
      var _props = this.props,
          prefixCls = _props.prefixCls,
          hideRequiredMark = _props.hideRequiredMark,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className,
          layout = _props.layout;

      var children = _react2.default.Children.map(this.props.children, function (child) {
        if (child && typeof child.type === 'function' && !child.props.size) {
          return _react2.default.cloneElement(child, { size: _this2.props.size });
        }

        return child;
      });

      cloneProps['children'] = children;

      var formClassName = (0, _classnames2.default)(prefixCls, (_classNames = {}, (0, _defineProperty2.default)(_classNames, prefixCls + '-horizontal', layout === 'horizontal'), (0, _defineProperty2.default)(_classNames, prefixCls + '-vertical', layout === 'vertical'), (0, _defineProperty2.default)(_classNames, prefixCls + '-inline', layout === 'inline'), (0, _defineProperty2.default)(_classNames, prefixCls + '-hide-required-mark', hideRequiredMark), _classNames), className);
      var formProps = (0, _omit2.default)(cloneProps, ['prefixCls', 'className', 'layout', 'form', 'hideRequiredMark']);

      return _react2.default.createElement('form', (0, _extends3.default)({}, formProps, { className: formClassName }));
    }
  }]);

  return Form;
}(_Form2.default);

Form.defaultProps = {
  prefixCls: 'ant-form',
  layout: 'horizontal',
  hideRequiredMark: false,
  onSubmit: function onSubmit(e) {
    e.preventDefault();
  },
  size: 'default'
};
Form.propTypes = {
  prefixCls: _propTypes2.default.string,
  layout: _propTypes2.default.oneOf(['horizontal', 'inline', 'vertical']),
  children: _propTypes2.default.any,
  onSubmit: _propTypes2.default.func,
  hideRequiredMark: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['large', 'default', 'small'])
};
Form.Item = _FormItem2.default;
Form.createFormField = _createFormField2.default;
Form.create = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _createDOMForm2.default)((0, _extends3.default)({ fieldNameProp: 'id' }, options, { fieldMetaProp: _constants.FIELD_META_PROP, fieldDataProp: _constants.FIELD_DATA_PROP }));
};

exports.default = Form;